import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as d from "../../reducers/domainReducer";
import * as types from "../../constants/actionTypes";
import { getFirstName, isRxRoute } from "../../helpers/formatting";
import MiniSpinner from "../common/MiniSpinner";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { PillButton } from "../ecosystem";
import * as msgs from "../../constants/textConstants";
import HeaderProxySelectorMobile from "./HeaderProxySelectorMobile";
import SingleUserSelector from './SingleUserSelector';
import UsersListDropdown from './UsersListDropdown';

const UsersList = (props) => {

    const {
        primaryUser, activeUser, myChartUsers, pharmacyUsers, onPrimaryUserSelected, onMyChartUserSelected,
        onPharmacyUserSelected, rxDown, hasPharmacyLogin, bundle, history, schedulingCompleted, orderRefillCompleted,
        rxTransferCompleted, serverData, hasAAL, hasHealthPlanLogin, onFamilyPlanUserSelected, proxyListLoading, isAdult, onClick,
        onViewAllSelected, currentMyChartUser, updateActiveUser, screenBreakPoint, isDashboardPage, isShowAllUsers, currentPharmacyUser, isSwitchingProxy
    } = props;

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [selectedLabel, setSelectedLabel] = React.useState("All");

    const enableFamilyPlan = serverData && serverData.combinedhp ? (hasAAL || hasHealthPlanLogin ? true : false) : false;
    const familyPlanUsers = [
    ];

    const pathname = history && history.location ? history.location.pathname : '/';

    const isPharmacyPage = (bundle === "pharmacy" || pathname === '/pharmacy' || isRxRoute(pathname));
    const isProxySelection = pathname.toLowerCase().indexOf("/familyselection") !== -1;

    const blockUserSwitch = () => {
        return pathname && pathname.toLowerCase().indexOf("/findcare/vaccine") !== -1;
    }

    useEffect(() => {
        const { proxySource, userId } = props;
        props.getRequestProxyUsers(proxySource, userId);
    }, []);

    useEffect(() => {
        if (isPharmacyPage && currentPharmacyUser && currentPharmacyUser.firstName && activeUser && currentPharmacyUser.pharmacyPatientId) {
            if (typeof activeUser.pharmacyPatientId === 'undefined' || (activeUser.pharmacyPatientId && activeUser.pharmacyPatientId !== currentPharmacyUser.pharmacyPatientId)) {
                updateActiveUser(currentPharmacyUser)
            }
            setSelectedLabel(currentPharmacyUser.firstName)
        } else if (currentMyChartUser && currentMyChartUser.displayName && activeUser && activeUser.displayName) {
            if (activeUser.displayName !== currentMyChartUser.displayName) {
                updateActiveUser(currentMyChartUser)
            }
            if (!isShowAllUsers) {
                setSelectedLabel(getFirstName(currentMyChartUser.displayName))
            } else {
                setSelectedLabel("All")
            }
        }
    }, [currentMyChartUser, currentPharmacyUser]);

    const myChartUsersCount = myChartUsers ? myChartUsers.length : 0;
    const pharmacyUsersCount = pharmacyUsers ? pharmacyUsers.length : 0;
    const familyPlanUsersCount = familyPlanUsers && enableFamilyPlan ? familyPlanUsers.length : 0;
    const totalUsersCount = myChartUsersCount + pharmacyUsersCount + familyPlanUsersCount;
    const rxRequestCompleted = (orderRefillCompleted && /rxrefill/.test(pathname.toLowerCase())) || (rxTransferCompleted && /bswtransfer/.test(pathname.toLowerCase()));
    const urlParms = history.location.search || history.location.searchParms;
    let urlPath = pathname + (urlParms ? urlParms : '');
    const singleUser = totalUsersCount == 0 ? true : false;
    const isMobile = !(screenBreakPoint === msgs.XL_DESKTOP || screenBreakPoint === msgs.XXL_DESKTOP || screenBreakPoint === msgs.LG_TABLET) ? true : false;

    if (pathname !== '/' && ((bundle === "pharmacy" || pathname.indexOf('/pharmacy') > -1) ||
        /^\/schedule\//.test(pathname) && schedulingCompleted)) {
        urlPath = '/';
    }


    //debugger;
    if (myChartUsers === null ||
        pharmacyUsers === null || proxyListLoading) { //Bug: 84558 - added this condition to make it in sync with the dashboard list with header list count for profile proxies.
        return <div className="proxy-dropdown"><MiniSpinner /></div>;
    }

    const onChange = (option) => {
        if (option && option.label && option.label === "View All") {
            setSelectedLabel("All")
            onViewAllSelected(primaryUser);
        }
        else if (primaryUser && option && option.user && primaryUser === option.user) {
            setSelectedLabel(option.label)
            onPrimaryUserSelected(primaryUser);
            history.push(urlPath);
        }
        if (myChartUsers && myChartUsers.length > 0 && option && option.user && myChartUsers.some(user => user === option.user)) {
            setSelectedLabel(option.label)
            onMyChartUserSelected(option.user)
            history.push(urlPath);
        }
        else if (pharmacyUsers && pharmacyUsers.length > 0 && option && option.user && pharmacyUsers.some(user => user === option.user)) {
            setSelectedLabel(option.label)
            onPharmacyUserSelected(option.user);
            const currentPathname = (pathname && isRxRoute(pathname) && !rxRequestCompleted) || blockUserSwitch() ? pathname : '/pharmacy';
            history.push(currentPathname);
        } else if (option && option.value && option.value === "GrantAccess") {
            onClick()
        }
    }

    const getProxyAccounts = () => {
        let proxyUser = [];
        if (primaryUser) {
            let primary = [{ value: "Your Account", label: "Your Account", className: "proxy-subheader" },
                {
                    user: primaryUser, value: primaryUser.displayName, label: getFirstName(primaryUser.displayName), showBadge: !isShowAllUsers && !isPharmacyPage && activeUser &&
                                                                                            primaryUser && activeUser.externalId && primaryUser.externalId && activeUser.externalId === primaryUser.externalId
                }];
            proxyUser = primary;
        }
        if (myChartUsers && myChartUsers.length > 0) {
            let chartUser = [{ value: "Family Medical Records", label: "Family Medical Records", className: "proxy-subheader" },
                { value: "All", label: "View All", className: `${!(isDashboardPage || isProxySelection) ? "disable-proxy-option" : ""}`, showBadge: ((isShowAllUsers && !isPharmacyPage) && (isDashboardPage || isProxySelection)) }];
            myChartUsers && myChartUsers.map(user => {
                chartUser.push({
                    user: user, value: user.displayName,
                    label: getFirstName(user.displayName),
                    showBadge: !isPharmacyPage && activeUser && activeUser.externalId && user.externalId && user.externalId === activeUser.externalId
                })
            })
            proxyUser = proxyUser.concat(chartUser);
        }
        if (pharmacyUsers && pharmacyUsers.length > 0) {
            let pharmacy = [{
                value: "Family BSWH Pharmacy Account", label: "Family BSW Pharmacy Account", className: "proxy-subheader" }];
            pharmacyUsers && pharmacyUsers.map(user => {
                pharmacy.push({
                    user: user, value: user.displayName,
                    label: getFirstName(user.displayName),
                    showBadge: isPharmacyPage && activeUser && activeUser.pharmacyPatientId && user.pharmacyPatientId && user.pharmacyPatientId === activeUser.pharmacyPatientId
                })
            })
            proxyUser = proxyUser.concat(pharmacy);
        }
        if (isAdult) {
            proxyUser = proxyUser.concat([{ value: "GrantAccess", label: "+Add or Grant Family Access", className: "grant-proxy-access" }]);
        }
        return proxyUser;
    }

    const onClickProxyBtn = () => {
        setDropdownOpen(!dropdownOpen);
    }

    return (singleUser
        ? <SingleUserSelector
            isAdult={isAdult}
        />
        : <div className="dropdown-proxy-selector">
            {isMobile
                ? <>
                    <PillButton
                        onClick={() => onClickProxyBtn()}
                        label={selectedLabel}
                        showArrow={true}
                    />

                    <HeaderProxySelectorMobile
                        isOpen={dropdownOpen}
                        setMobileMenuOpen={setDropdownOpen}
                        activeUser={activeUser}
                        primaryUser={primaryUser}
                        userList={myChartUsers}
                        onChange={onChange}
                        pharmacyUsers={pharmacyUsers}
                        isAdult={isAdult}
                        isShowAllUsers={isShowAllUsers}
                        bundle={bundle} />
                </>
                :
                <UsersListDropdown
                    onChange={onChange}
                    selectedOption={selectedLabel}
                    options={getProxyAccounts()}
                    badgeLabel="Viewing"
                />
            }
        </div>
        
    );
}

const mapStateToProps = (state) => {
    let pl = [];

    if (state.domain.pl) {
        state.domain.pl.forEach((c, index, arr) => {
            pl.push(d.hydrateProxyUser(c));
        });

    }

    if (pl.length > 0) {
        pl.shift(); // remove the logged-in user from the list
    }

    let proxySource = 'Rx';
    if (state.domain.hm) {
        proxySource = "Rx,Epic";
    }
    /*else if (state.domain.hm) {
        proxySource = "Epic";
    }
    else if (state.domain.hp) {
        proxySource = "Rx";
    }*/

    const proxyUsers = state.common[types.REQUEST_PROXY_ACCESS_LIST];

    let pharmacyProxyUsers = proxyUsers && proxyUsers.response && proxyUsers.response.filter(userAccess => userAccess.proxySource && userAccess.proxySource.toLowerCase() === 'rx');

    const { submitOrderResult, transfer } = state.pharmacy;

    return {
        rxDown: state.common.rxDown,
        hasPharmacyLogin: state.memberships.isActiveFeature_Pharmacy,
        myChartUsers: pl,
        pharmacyUsers: pharmacyProxyUsers,
        bundle: state.session.serverData.bundle.toLowerCase(),
        history: state.session.history,
        schedulingCompleted: state.openScheduling.scheduleAppointmentSuccess || state.openScheduling.scheduleAppointmentFailed,
        orderRefillCompleted: submitOrderResult && (submitOrderResult.SuccessRx || submitOrderResult.RenewedRx || submitOrderResult.FailuresRx),
        rxTransferCompleted: transfer && (transfer.error || transfer.result),
        hasAAL: !state.common.aalDown && state.memberships.hasAA,
        hasHealthPlanLogin: !state.common.swhpDown && state.memberships.hasAnySWHP,
        serverData: state.session.serverData,
        userId: state.domain.un,
        hasMyChartLogin: state.domain.hm,
        proxySource: proxySource,
        proxyListLoading: state.memberships.proxyListLoading,
        currentMyChartUser: d.hydrateProxyUser(state.domain.cu),
        screenBreakPoint: state.common.screenBreakPoint,
        isShowAllUsers: state.dashboard.isShowAllUsers,
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu),
        isSwitchingProxy: state.memberships.switchingProxyUser
    };
};

const mapDispatchToProps = (dispatch) => {

    return {
        getRequestProxyUsers: (proxySource, userId) => dispatch({ type: types.REQUEST_PROXY_ACCESS_LIST, data: { userId, proxySource } })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UsersList));